export default __webpack_public_path__ + "static/media/info-mesa-ayuda.2c591ab6.svg";